import { apiClient } from './apiService';
import {
  BRANCH_QR_MENU,
  BRANCH_QR_MENU_GENERATE,
  PUBLIC_QR_MENU_DATA
} from './endpoints';

export interface QrMenuStatus {
  branchId: number;
  branchName: string;
  enabled: boolean;
  token: string | null;
  url: string | null;
}

export interface QrMenuProduct {
  id: number;
  name: string;
  description?: string | null;
  price?: number | string | null;
  basePrice?: number | string | null;
  file?: { url?: string } | null;
}

export interface QrMenuCategory {
  id: number;
  name: string;
  products: QrMenuProduct[];
}

export interface QrMenuData {
  branch: { id: number; name: string };
  company: { id: number; name: string };
  categories: QrMenuCategory[];
}

export const qrMenuService = {
  async getStatus(branchId: number): Promise<QrMenuStatus> {
    const response = await apiClient.get<QrMenuStatus>(
      BRANCH_QR_MENU.replace(':branchId', String(branchId))
    );
    return response.data;
  },

  async generate(branchId: number, regenerate = false): Promise<QrMenuStatus> {
    const url = BRANCH_QR_MENU_GENERATE.replace(':branchId', String(branchId));
    const response = await apiClient.post<QrMenuStatus>(
      regenerate ? `${url}?regenerate=true` : url
    );
    return response.data;
  },

  async disable(branchId: number): Promise<void> {
    await apiClient.delete(
      BRANCH_QR_MENU.replace(':branchId', String(branchId))
    );
  },

  async getMenuData(token: string): Promise<QrMenuData> {
    const response = await apiClient.get<QrMenuData>(
      PUBLIC_QR_MENU_DATA.replace(':token', token)
    );
    return response.data;
  }
};
